































import Vue, { PropType } from 'vue';
import SectionRow from './SectionRow.vue';
import { CvSectionProfile } from '@/../gen';

export default Vue.extend({
  components: {
    SectionRow,
  },
  props: {
    profile: {
      type: Object as PropType<CvSectionProfile>,
      required: true,
    },
  },
  computed: {
    editLink() {
      return {
        name: 'cv_section_profile_edit_path',
        params: { id: this.profile.cv_id },
      };
    },
    profileImageUrl() {
      const { profile_image } = this.profile;
      if (profile_image && profile_image.url) {
        return profile_image.url.sm ? profile_image.url.sm : profile_image.url;
      }
      // TODO replace by ENV default
      return 'https://proff-local.s3-ap-northeast-1.amazonaws.com/images/default-profile-icon.png';
    },
  },
});
